module.exports = __webpack_public_path__ + "static/Gotham-Book-b2df24321c7e2c2e59319f692de5fdee.ttf";